import { createContext, useContext, useReducer, useEffect } from "react";
import reducer from "../reducer/cartReducer";

const CartContext = createContext();

 const getLocalCartData = () => {
   let localCartData = localStorage.getItem("gearlogyCart");
  //  if (localCartData === []) {         //if no product is added return empty data
  //    return [];
  //  } else {                          //if products are added then return the data added to the cart
  //    return JSON.parse(localCartData);         //converts a JSON string to a JavaScript object
  //  } 
  const parsedData = JSON.parse(localCartData)
  if(!Array.isArray(parsedData)) return [];
  return parsedData; 
 };


const initialState = {
  cart: getLocalCartData(),
  total_item: "",
  total_amount: "",
  shipping_fee: 50000,
};

const CartProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addToCart = (id, color, amount, product) => {
    dispatch({ type: "ADD_TO_CART", payload: { id, color, amount, product } });
  };

  
   // increment and decrement the product
   const setDecrease = (id) => {
    dispatch({ type: "SET_DECREMENT", payload: id });
  };

  const setIncrement = (id) => {
    dispatch({ type: "SET_INCREMENT", payload: id });
  };


  //to remove individual item from cart
  const removeItem = (id) => {
    dispatch({ type: "REMOVE_ITEM", payload: id });
  };

  //to clear the cart completely
  const clearCart = () => {
    dispatch({ type: "CLEAR_CART" });
  };

   // to add the data in localStorage
  // get vs set
  useEffect(() => {
    dispatch({ type: "CART_TOTAL_ITEM" });        //to get the total item in cart
    dispatch({ type: "CART_TOTAL_PRICE" });       //to get the total price of all the products in cart
    localStorage.setItem("gearlogyCart", JSON.stringify(state.cart));   //set the data in local storage//JSON.stringify() converts a JavaScript object or value to a JSON string
  }, [state.cart]);

  return (
    <CartContext.Provider value={{ ...state, addToCart, removeItem, clearCart, setDecrease,
      setIncrement, }}>
      {children}
    </CartContext.Provider>
  );
};

const useCartContext = () => {
  return useContext(CartContext);
};

export { CartProvider, useCartContext };